import script from "./GestionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GestionView.vue?vue&type=script&lang=ts&setup=true"

import "./GestionView.vue?vue&type=style&index=0&id=ac1a3eee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac1a3eee"]])

export default __exports__